<script lang="ts">
  import BasketStatus from "$lib/components/Nav/BasketStatusIcon/BasketStatusIcon.svelte";

  import { cart } from "$lib/stores/cart";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import { _ } from "svelte-i18n";

  $: quantity = $cart?.totalQuantity;

  export let close: () => void;
</script>

<style lang="scss">
  .content {
    padding-top: 1.75rem;
    padding-right: 1.75rem;
    padding-left: 1.75rem;
    display: flex;
    flex-direction: column;

    &--added {
      display: flex;
      justify-content: space-between;
    }
  }
</style>

<div class="content">
  {#if quantity > 0}
    <div class="content--added">
      <Typography variant="caption2">{$_("minicart.addedtobag")}</Typography>
      <div
        class="nav-icons--basket"
        on:click={close}
        on:keypress={close}
        role="button"
        tabindex="0"
      >
        <BasketStatus {quantity} theme="on-surface" on:click />
      </div>
    </div>
  {/if}
</div>
